import { v4 as uuidv4 } from 'uuid';
import Form from "../../../components/base/form-v2/form";
import FormEventSubscription from "../../../components/base/form-v2/form-event-subscription";
import {AnalyticsService} from "../../../services/analytics-service";
import ServiceLocator from "../../../global/service-locator";

export default class ProfTestChatForm {
    constructor(testId, answers, callback) {
        this.testId = Number(testId);
        this.answers = answers;

        this.sl = ServiceLocator.instance;
        this.sidFid = AnalyticsService.getFidCid();

        this.submitCallback = callback;

        this.form = null;

        this.init();
    }

    init() {
        this.form = new Form({
            id: 'profTestChatPostForm',
            path: '/1.0/courses/proftest',
            data: {
                cid: this.sidFid.cid,
                fid: this.sidFid.fid,
                fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                lmsUserId: this.sl.userDataService.getLMSUserId(),
                lang: document.querySelector('html').lang,
                testId: this.testId,
                answers: this.answers,
            },
            withCredentials: '',
            intlDropdownPositions: 'above',
            subscriptions: [
                new FormEventSubscription({
                    event: 'beforeSubmit',
                    callback: () => {
                        const conversionId = uuidv4();
                        const submitData = this.form.controller.getSubmitData();

                        const dataLayerEventData = {
                            event: 'prof_test_form',
                            formId: 'proftest',
                            phone: submitData.body.tel,
                            email: submitData.body.email,
                            conversion_id: conversionId
                        };

                        AnalyticsService.sendEvent('prof_test_form', dataLayerEventData);
                    }
                }),
                new FormEventSubscription({
                    event: 'submitComplete',
                    callback: (responce) => {
                        this.submitCallback(responce);
                    }
                })
            ]
        });
    }
}